import script from "./CreateProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProduct.vue?vue&type=script&setup=true&lang=js"

import "./CreateProduct.vue?vue&type=style&index=0&id=769cd424&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769cd424"]])

export default __exports__